'use es6';

export default (getState => {
  const {
    auth,
    view
  } = getState();
  return auth.user ? auth.user.user_id : view.presentation.presentation.userId;
});